module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "patientChatWindow"
  }, [_c('div', {
    staticClass: "titletop"
  }, [_c('x-header', {
    staticClass: "zdyheaderBlue",
    attrs: {
      "left-options": _vm.headoption
    }
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.headoption.showBack),
      expression: "!headoption.showBack"
    }],
    attrs: {
      "slot": "left"
    },
    on: {
      "click": _vm.closepage
    },
    slot: "left"
  }, [_vm._v("关闭")])]), _vm._v(" "), (_vm.patientMsg.length == 0) ? _c('divider', {
    staticStyle: {
      "margin-top": "46px"
    }
  }, [_vm._v("医生回复仅供参考，不作为诊断和治疗估量")]) : _vm._e(), _vm._v(" "), (_vm.patientMsg.length == 0) ? _c('p', {
    staticClass: "tel"
  }, [_vm._v("如有疑问,请拨打客服电话："), _c('a', {
    staticStyle: {
      "color": "#4ba7e8"
    },
    attrs: {
      "href": "tel:02782889968"
    }
  }, [_vm._v("027-82889968")])]) : _vm._e(), _vm._v(" "), (_vm.patientMsg.length != 0) ? _c('div', {
    staticClass: "msgdetail"
  }, [_c('p', [_c('span', [_vm._v("姓名："), _c('em', [_vm._v(_vm._s(_vm.patientMsg[0]))])]), _c('span', [_vm._v("性别："), _c('em', [_vm._v(_vm._s(_vm.patientMsg[1]))])]), (_vm.patientMsg[2].length != 0) ? _c('span', [_vm._v("年龄："), _c('em', [_vm._v(_vm._s(_vm.patientMsg[2]))])]) : _vm._e(), (_vm.patientMsg[3].length != 0) ? _c('span', [_vm._v("患者来源："), _c('em', [_vm._v(_vm._s(_vm.patientMsg[3]))])]) : _vm._e(), (_vm.patientMsg[4].length != 0) ? _c('span', [_vm._v("介绍人："), _c('em', [_vm._v(_vm._s(_vm.patientMsg[4]))])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.doctorMsg.length != 0) ? _c('div', {
    staticClass: "msgdetail"
  }, [_c('p', [_vm._v(_vm._s(_vm.doctorMsg[0]) + " 擅长：" + _vm._s(_vm.doctorMsg[1]))])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('v-scroll', {
    attrs: {
      "on-refresh": _vm.onRefresh,
      "on-infinite": _vm.onInfinite
    },
    on: {
      "childincrem": _vm.childincrem,
      "incre": _vm.increment
    }
  }, [_c('ul', {
    staticClass: "messagesList"
  }, _vm._l((_vm.chatList), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "item",
      class: item.object
    }, [_c('img', {
      attrs: {
        "src": item.img
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "whatsay"
    }, [_c('p', {
      staticClass: "time"
    }, [_vm._v(_vm._s(item.createdDate))]), _vm._v(" "), (item.url == null) ? _c('div', {
      staticClass: "whatsay_svg"
    }) : _vm._e(), _vm._v(" "), (item.url == null) ? _c('div', {
      staticClass: "whatsay_text"
    }, [_vm._v("\n              " + _vm._s(item.context) + "\n            ")]) : _vm._e(), _vm._v(" "), (item.url != null) ? _c('div', {
      staticClass: "divImg"
    }, [_c('inline-loading', {
      staticClass: "imgLoading"
    }), _vm._v(" "), _c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (item.src),
        expression: "item.src"
      }],
      key: item.src,
      staticClass: "previewer-demo-img",
      attrs: {
        "lazy": "loading"
      },
      on: {
        "click": function($event) {
          _vm.show(item.src)
        }
      }
    })], 1) : _vm._e()])])
  }))])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.footerShow),
      expression: "footerShow"
    }],
    ref: "inputBox",
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "imgBtn",
    on: {
      "click": function($event) {
        _vm.imgUPdate()
      }
    }
  }), _vm._v(" "), _c('x-textarea', {
    staticClass: "messagesClass",
    attrs: {
      "type": "text",
      "rows": 1,
      "autosize": true
    },
    on: {
      "on-enter": function($event) {
        _vm.sendTxt()
      },
      "on-focus": function($event) {
        _vm.messagesfous()
      },
      "on-change": function($event) {
        _vm.scrollBottom()
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.messagesClick($event)
      }
    },
    model: {
      value: (_vm.messages),
      callback: function($$v) {
        _vm.messages = $$v
      },
      expression: "messages"
    }
  }), _vm._v(" "), _c('x-button', {
    staticClass: "sendBtn",
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.sendTxt($event)
      }
    }
  }, [_vm._v("发送")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('previewer', {
    ref: "previewer",
    attrs: {
      "list": _vm.list,
      "options": _vm.options
    },
    on: {
      "on-close": _vm.imgClose
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b91876f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/project/onlineServicesProject/patient/patientChatWindow.vue
// module id = cBKF
// module chunks = 6